import {RootState} from 'src/store/store';

export const getAllAttributesCount = (state: RootState): number => state.counts.data.attributes;

export const getAllEventsCount = (state: RootState): number => state.counts.data.events;

export const getChangeRequestsCount = (state: RootState): number => state.counts.data.changeRequests;
